/* eslint-disable */
import { navWrapper } from './wrapper/NavWrapper'
import { productsWrapper } from './wrapper/ProductsWrapper'
import { navListener } from './core/NavListener'
import { scrollService } from './service/ScrollService'
window.addEventListener('DOMContentLoaded', async () => {

	const navwrappercontainer = document.querySelector('#category-lists')
	const productswrappercontainer  = document.querySelector('#product-categories')
	if (navwrappercontainer) {
		navWrapper.setContainer(navwrappercontainer)
		
		productsWrapper.setNavWrapper(navWrapper)
		productsWrapper.setContainer(productswrappercontainer)
		navListener.setProducts(productsWrapper.products)
		scrollService.addListener()
		scrollService._listenToScroll()
	}
})

